import React from 'react';
import { Row, Col } from 'react-bootstrap';
import './style.scss';
export default props => <Row className={props.className}>
    <Col className='zt-divider'></Col>
</Row>